export default function ContactForm() {
  return (
    <form
      className='shadow-lg bg-zinc-900 p-3 flex flex-col w-full rounded-lg gap-3'
      action=''
      method='POST'
    >
      <input
        className='bg-white/10 text-white rounded-md focus:ring-2 focus:ring-white/20 outline-none p-2 text-sm'
        type='text'
        name='name'
        placeholder='Enter your name'
      />
      <input
        className='bg-white/10 text-white rounded-md focus:ring-2 focus:ring-white/20 outline-none p-2 text-sm'
        type='text'
        name='email'
        placeholder='Enter your email'
      />
      <textarea
        className='w-full bg-white/10 rounded-md focus:ring-2 focus:ring-white/20 h-32 outline-none text-white py-1 px-3 resize-none leading-6 transition-colors duration-200 ease-in-out'
        name='message'
        rows={10}
        placeholder='Enter your message here...'
      />
      <button
        className='inline-flex items-center justify-center px-5 py-3 text-base font-semibold text-center bg-white/10 text-white rounded-md hover:bg-teal-500
          transition-all'
      >
        <span>Submit</span>
      </button>
    </form>
  )
}
